import React, { useEffect, useState } from 'react';
import { fetchDelayedJourneys, JourneyOrder } from './fetchJourneyOrder';
import { Loader } from '../../../components/Loader/Loader';
import { useHistory } from 'react-router-dom';
import './Journey.scss';
import Journey from './Journey';
import { InputComponent } from '../../../ReusableComponents/Input/InputComponent';
import Button from '../../../components/buttons/Button';

export default function JourneysPage(): JSX.Element {
  const [delayedJourneyOrders, setDelayedJourneyOrders] = useState<
    JourneyOrder[] | undefined
  >(undefined);
  const [fromOrderId, setFromOrderId] = useState<string>('');
  const [previousFromOrderIds, setPreviousFromOrderIds] = useState<string[]>(
    []
  );
  const history = useHistory();

  useEffect(() => {
    fetchDelayedJourneys(undefined).then(setDelayedJourneyOrders);
  }, []);

  const onKeyPressFromOrderId = (
    event: React.KeyboardEvent<HTMLDivElement>
  ) => {
    if (event.key === 'Enter') {
      fetchDelayedJourneys(fromOrderId).then(setDelayedJourneyOrders);
    }
  };

  if (delayedJourneyOrders === undefined) {
    return <Loader size={'xxl'} />;
  }

  const onPressNext = async () => {
    const lowestOrderId = delayedJourneyOrders[0]
      ? delayedJourneyOrders[0].order.id
      : '';
    const journeys = await fetchDelayedJourneys(lowestOrderId);
    setDelayedJourneyOrders(journeys);
    setPreviousFromOrderIds(previousFromOrderId =>
      previousFromOrderId.concat(fromOrderId)
    );
    setFromOrderId(lowestOrderId);
  };

  const onPressPrevious = async () => {
    const previousId = previousFromOrderIds[previousFromOrderIds.length - 1];
    const journeys = await fetchDelayedJourneys(previousId);
    setDelayedJourneyOrders(journeys);
    setPreviousFromOrderIds(previousFromOrderId =>
      previousFromOrderId.slice(0, -1)
    );
    setFromOrderId(previousId);
  };

  return (
    <div className="journey-page">
      <h2 className="title">Delayed journeys</h2>
      <p>
        Show's the journey of orders that have a leg that is not marked as
        completed within arrival date. Useful for validating the progress of
        tracking order journeys :)
      </p>
      <div className="journey-navigation">
        <InputComponent
          id="order-id-input"
          label="From order id"
          name="from-order-id"
          type="number"
          value={fromOrderId}
          onChange={event => setFromOrderId(event.target.value)}
          onKeyPress={onKeyPressFromOrderId}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            height: '40px',
          }}
        >
          <Button
            title="<"
            onClick={onPressPrevious}
            disabled={previousFromOrderIds.length === 0}
            style={{ maxWidth: '40px' }}
          />
          <Button
            title=">"
            onClick={onPressNext}
            disabled={false}
            style={{ maxWidth: '40px' }}
          />
        </div>
      </div>
      {[...delayedJourneyOrders].reverse().map(journeyOrder => {
        return (
          <div
            className="journey-list-element"
            key={journeyOrder.order.id}
            onClick={() => history.push(`/journey/${journeyOrder.order.id}`)}
          >
            <Journey journeyOrder={journeyOrder} deviations={[]} />
          </div>
        );
      })}
    </div>
  );
}
